/**
 * Which kind of input the student is actually using.
 *
 * Several surfaces word themselves around the hand at the controls: the
 * approach card names a key a phone does not have, and the entry screen
 * teaches WASD to people who have no W. They all need the same answer, and
 * they need it to change together when the hand changes - so the tracking
 * lives here once rather than as a private copy in each surface.
 *
 * Watched from actual events rather than sniffed from the user agent: a
 * convertible with both a trackpad and a screen gets the wording for
 * whichever it used last. The media query only seeds the answer for the
 * moment before any input arrives.
 */

let touch = window.matchMedia('(pointer: coarse)').matches

const listeners = new Set<() => void>()

// Passive and capture-phase, so it sees every press no matter who handles it
// or stops its propagation.
window.addEventListener(
  'pointerdown',
  (e) => {
    const now = e.pointerType === 'touch'
    if (now === touch) return
    touch = now
    for (const listener of [...listeners]) listener()
  },
  { capture: true, passive: true },
)

/** True when the last press was a finger. */
export const touchInput = (): boolean => touch

/**
 * Called when the modality flips, for surfaces that are not redrawn every
 * frame anyway. Returns the unsubscribe.
 */
export function onInputModeChange(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
